import React from 'react';
import { getToken } from '../../_utils/storage_handler';
import { Result, Button } from 'antd';

const AuthWrapper = (AuthComponent) => (
    class extends React.Component{

        validateSession = () => {
            let token = getToken();
            if(token === null){
                return false;
            }
            return true;
        }

        render(){
            if(this.validateSession()){                
                return(<AuthComponent {...this.props} />);
            } else {
                return(
                    <Result
                        status="error"
                        title="No estas autorizado"
                        subTitle="Para ingresar debes hacer login"
                        extra={[
                        <Button onClick={() => window.location.href = '/'} type="primary" key="console">
                            Ir a login
                        </Button>
                        ]}
                    />
                );
            }
        }
    }
);

export default AuthWrapper;